import { render } from "./Footer.vue?vue&type=template&id=3313a4aa&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=3313a4aa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3313a4aa"

export default script